import { lazy, Suspense } from "react"

import { FallbackCardDashboard } from "@/pages/DashboardPage/components/organisms/FallbackCardDashboard"

const RemediationCoverageWidgetComponent = lazy(() =>
  import("./RemediationCoverageWidgetComponent").catch(() => ({
    default: () => <FallbackCardDashboard title="Remediation Coverage" />
  }))
)

import type { RemediationCoverageWidgetProps } from "."

export const RemediationCoverageWidget = (
  props: RemediationCoverageWidgetProps
) => {
  const { isLoading: _, ...rest } = props

  return (
    <Suspense fallback={<FallbackCardDashboard {...rest} />}>
      <RemediationCoverageWidgetComponent {...props} />
    </Suspense>
  )
}
